/* eslint-disable prettier/prettier */
import Component from '../abstracts/Component';
import ajaxAction from '../utils/ajaxUtil';
import TrackingComponent from '../components/TrackingComponent';
import { SWITCH_TOGGLE_EVENTS } from '../components/SwitchComponent'
import { SLIDER_EVENTS } from '../components/PriceRangeComponent'
import SaleRangeComponent from '../components/SaleRangeComponent';
import {getFocusElement, hasFocusElement} from '../utils/BrowserHistoryUtils';
import _ from 'lodash';
import Cookies from 'js-cookie';
import { trapFocusOnModal } from '../utils/TrapFocusOnModalUtils';

export default class FiltersComponent extends Component {
  get SELECTORS() {
    return {
      viewModeV4: '[data-view-mode-v4]',
      viewModeV6: '[data-view-mode-v6]',
      sideBar: '[data-side-bar]',
      sideBarOverlay: '[data-side-bar-overlay]',
      openSideBar: '[data-side-bar-open]',
      openSideBarMobile: '[data-side-bar-open-mobile]',
      closeSideBar: '[data-side-bar-close]',
      activeItem: '[data-side-bar-filters-item].active',
      filterActive: '[data-filters-item].active',
      subMenuSideBar: '[data-filter-side-bar-sub-menu]',
      filters: '[data-filters-item]',
      filterList: '[data-side-bar-filters-item]',
      filterListClose: '[data-filter-side-bar-sub-back]',
      filterListCloseAll: '[data-filter-side-bar-sub-close]',
      filterElement: '[data-filter-element]',
      cleanAll: '[data-side-bar-clean]',
      cleanSingle: '[data-reset-filter-wrapper]',
      showResultLabel: '[data-show-result]',
      filterOptionsSelected: '[data-filter-side-bar-filters-item-secondary-line]',
      filterCategory: '[data-filter-side-bar-filters-item-name]',
      resetAllFilterButton: '[data-side-bar-clean]',
      resetCategoryFilterButtons: '[data-filter-side-bar-sub-reset]',
      mobileFilterButton: '[data-side-bar-open-mobile]',
      productCounter: '[data-filter-bar-nArticle]',
      productsContainer: '[data-products-container]',
      categoryFilterActiveCounter: '[data-filter-side-bar-sub-menu-counter]',
      searchResultsCount: '#filter-bar-nArticle',
      showResultButtonList: '.filter-side-bar-sub-menu-apply-filters',
    }
  }
  get OLD_SELECTORS() {
    return {
      filtersButton: '[data-trigger-filters]',
      filtersContainer: '[data-filters-container]',
      filtersContent: '[data-filters-content]',
      listItems: '[data-filters-item]',
      listItemActive: '[data-filters-item].active',
      liveSubItem: '[data-item-parent-name].live',
      subListPanel: '[data-sublist-container]',
      closeBtn: '[data-trigger-close]',
      closeBtnMobile: '[data-trigger-close-mobile]',
      ctaClear: '[data-cta-clear]',
      ctaView: '[data-cta-view]',
      benefitBar: '[data-benefit-bar]',
      itemText: '[data-item-text]',
      sublistTitle: '[data-sublist-title]',
      sublistText: '[data-sublist-text]',
      productsContainer: '[data-products-container]',
      //END WIP
      filtersInputs: '[data-filter-input]:not([name="rangePriceFilter"])',
      priceFilterInputs: 'input[name="rangePriceFilter"]',
      filterSortBy: '[data-filter-sortby]',
      inputs: '.w-f__sublist__item input[type="checkbox"]',
      priceMobileInputs: '[data-mobile-price-filter] input',
      priceMobileContainer: '.w-f__sublist.price-mobile',
      mobileResultsCount: '[data-mobile-results-count]',
      searchResultsCount: '#filter-bar-nArticle',
      saleRangeMobileInputs: '[data-mobile-sale-range-filter] input',
      saleRangeMobileContainer: '.w-f__sublist.sale-range-mobile',
      removeFilters: '.remove-filters',
      removeFiltersEmptySearch: '.remove-filters.empty-search',
      filters: '.w-filters',
    };
  }

  get CSS_CUSTOMVARS() {
    return {
      jsHeightFilterbar: '--js-header-height',
      jsVh: '--vh',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.$component = htmlEl;
    // INTREND
    this.viewModeV4 = document.querySelector(this.SELECTORS.viewModeV4);
    this.viewModeV6 = document.querySelector(this.SELECTORS.viewModeV6);
    this.sideBar = document.querySelector(this.SELECTORS.sideBar);
    this.sideBarOverlay = document.querySelector(this.SELECTORS.sideBarOverlay);
    this.openSideBar = document.querySelector(this.SELECTORS.openSideBar);
    this.openSideBarMobile = document.querySelector(this.SELECTORS.openSideBarMobile);
    this.closeSideBar = document.querySelector(this.SELECTORS.closeSideBar);
    this.cleanAll = document.querySelector(this.SELECTORS.cleanAll);
    this.mobileFilterButton = document.querySelector(this.SELECTORS.mobileFilterButton);
    this.productCounter = document.querySelector(this.SELECTORS.productCounter);
    this.productsContainer = document.querySelector(this.SELECTORS.productsContainer);
    this.showResultButtonList = document.querySelectorAll(this.SELECTORS.showResultButtonList);
    this.filterbarHeight = $('.filter-bar-wrapper')?.offset().top ?? 0
    this.minSelected = {}
    this.maxSelected = {}
    this.showResultLabel = document.querySelectorAll(this.SELECTORS.showResultLabel);

    let queryFromUrl = window.location.search.startsWith('?page=') ? '' : window.location.search.replace('?isRefineSearch=true&q=', '') ?? '';
    let t = queryFromUrl !== '' ? queryFromUrl.split(':') : null

    // TODO smontare tutto e leggere i data attributes degli elemnts per capire cosa  attivo
    const url = new URL(window.location);
    let urlSearchParams = new URLSearchParams(url.search);
    this.pageNum = urlSearchParams.get("page") ?? ""
    this.qParams = urlSearchParams;
    this.textSearch = this.qParams.get('text');

    this.filterComponents = document.querySelectorAll('[data-filter-category]');
    this.filterComponents = [...this.filterComponents].filter(f => f.getAttribute('data-filter-category') !== 'sortBy');

    this.query = ''
    if (t) {
      this.query = `:${t.slice(2).join(':')}`
    }
    let regex = /[?&]page=\d+/g;
    this.query = this.query.replace(regex, '');
    this.sortQuery = t ? `:${t[1]}`: ':topRated'; // base sort

    this.ajaxAction = new ajaxAction();

    // extra components
    this.trackingComponent = new TrackingComponent();
    this.SaleRangeComponent = new SaleRangeComponent(htmlEl);
    this.checkSelectedLayout();
  }

   // update products counter
   updateSearchResultsCountFromWishlist({payload}) {
    console.log(this.$component.querySelector(this.SELECTORS.searchResultsCount));
    console.log(document.querySelector(this.SELECTORS.searchResultsCount));
    if(this.$component.querySelector(this.SELECTORS.searchResultsCount) != null) {
      this.$component.querySelector(this.SELECTORS.searchResultsCount).innerHTML = payload.label;
    }
  }
  checkSelectedLayout(){
    let gridLayoutSettings = Cookies.get('gridLayoutSettings');
    if (gridLayoutSettings === 'false' || gridLayoutSettings == null || $('.filter-bar-gridSelectors').length == 0) {
      this.handleViewMode('V4');
      Cookies.set('gridLayoutSettings', 'V4', { expires: 1 });
    } else {
      this.handleViewMode(Cookies.get('gridLayoutSettings'));
    }
  }

  openSideBarFilters() {
    this.sideBar.classList.add('show');
    this.sideBarOverlay.classList.add('show');
    this.sideBar.classList.remove('hide');
    this.sideBarOverlay.classList.remove('hide');

    const sideBarVisible = document.querySelector('.filter-side-bar.show:not(.hide)');
    if (sideBarVisible){
      trapFocusOnModal(sideBarVisible);
      const sideBarClean = sideBarVisible.querySelector('.filter-side-bar-clean');
      if (sideBarClean) {
        sideBarClean.focus();
      }
    }
  }

  bindEvents() {
    // INTREND

    this.viewModeV4.addEventListener('click', () => {
      this.handleViewMode('V4');
      Cookies.set('gridLayoutSettings', 'V4', { expires: 1 });
      if (document.querySelectorAll(".carousel-wrapper").length) {
        this.importLibrary();
      }
    });
    this.viewModeV6.addEventListener('click', () => {
      this.handleViewMode('V6');
      Cookies.set('gridLayoutSettings', 'V6', { expires: 1 });
      if (document.querySelectorAll(".carousel-wrapper").length) {
        this.importLibrary();
      }
    });
    if (this.openSideBar) {
      this.openSideBar.addEventListener('click', () => {
        this.openSideBarFilters();
      });
      this.openSideBar.addEventListener('keypress', () => {
        this.openSideBarFilters();
      });
    }
    if (this.openSideBarMobile) {
      this.openSideBarMobile.addEventListener('click', () => {
        this.sideBar.classList.add('show');
        this.sideBarOverlay.classList.add('show');
        this.sideBar.classList.remove('hide');
        this.sideBarOverlay.classList.remove('hide');
      });
    }
    this.closeSideBar.addEventListener('click', () => {
      // TODO: add event to change view mode
      this.sideBar.classList.add('hide');
      this.sideBarOverlay.classList.add('hide');
      this.sideBar.classList.remove('show');
      this.sideBarOverlay.classList.remove('show');
    });
    this.sideBarOverlay.addEventListener('click', () => {
      // TODO: add event to change view mode
      this.sideBar.classList.add('hide');
      this.sideBarOverlay.classList.add('hide');
      this.sideBar.classList.remove('show');
      this.sideBarOverlay.classList.remove('show');

      const subMenuSideBar = document.querySelectorAll(this.SELECTORS.subMenuSideBar);
      subMenuSideBar.forEach(menuItem => {
        menuItem.classList.remove('active');
        menuItem.classList.add('hide');
      });

    });

    this.handleSubItemMenu(); // Listener to open sub menu from side bar
    this.handleSubItemMenuFromFilterBar(); // Listener to open sub menu from filter bar
    this.onFilterTabItemClick(); // Click on filter tab item
    this.onSideBarItemClick(); // Click on sidebar item
    this.onCloseSideBarSubMenu();
    this.onCloseSideBarFromSubMenu();

    this.addClickElementFilter();
    this.onResetFilterClick();
    this.onResetFilterCategoryClick();
    this.bindCloseFilterBar()
    this.handleSticky();

    this.$on(this.$customEvents.SHORTCUT_EVENTS.update, ({payload}) => {
        if(payload.resetFilters){
            this.query = '';
            this.sortQuery = ':topRated';
            this.resetAllFilters();
            let currentUrl = window.location.href
            let newUrl = currentUrl.split('?')[0];
            window.history.replaceState( {} , '', newUrl );
        }
        this.applyFilters('', true, payload.fullQuery);
    })

    this.$on(this.$customEvents.PAGINATOR.change, ({payload}) => {
      const qParams = new URLSearchParams(window.location.search);
      if(qParams && qParams.size){
        qParams.set('isRefineSearch', 'true');
        qParams.set('page', payload.page);
      } else {
        qParams.set('page', payload.page);
      }
      this.pageNum = payload.page;
      this.applyFilters(payload.page, true);
    })

    this.$on(this.$customEvents.FILTERS_EVENTS.reset, ({payload}) => {
      // check if filters are available after filtering
      console.warn("Filters_events.reset trigger");

      this.refreshFilters(payload.response);
      this.refreshFilterBar(payload.response);
      this.refreshCleanButtons(payload.response)
      this.refreshShowResult(payload.response)
      this.refreshSideBarSelectedItems(payload.response)
      this.refreshAllCleanButtons(payload.response)
      this.refreshMobileFilterButton(payload.response)
      this.refreshCounter(payload.response)
      this.refreshCategoryCounter(payload.response)
      this.refreshSlider(payload.response, 'rangePriceFilter', true)
      this.refreshSlider(payload.response, 'saleRangePriceFilter', true)
      this.refreshSwitchToggle(payload.response, 'inSales')
      this.refreshSwitchToggle(payload.response, 'newArrival')
      this.refreshSwitchToggle(payload.response, 'specialPrice')

      let queryFromUrl = payload.query.startsWith('?page=') ? '' :payload.query.replace('?isRefineSearch=true&q=', '') ?? '';
      let t = queryFromUrl !== '' ? queryFromUrl.split(':') : null
      let urlSearchParams = new URLSearchParams(payload.query);
      this.pageNum = urlSearchParams.get("page") ?? ""
      let regex = /[?&]page=\d+/g;
      if (t) {
        this.query = `:${t.slice(2).join(':')}`
      }
      if(this.query){
          this.query = this.query.replace(regex, '');
      }

      let newQs = payload.query.replace(this.QUERY_PARAMS.base() + '&', '?');
      history.replaceState(null, null, newQs);
    })

    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({payload}) => {
      // check if filters are available after filtering
      console.warn("Filters_events.updated trigger");

      this.refreshFilters(payload.response);
      this.refreshFilterBar(payload.response);
      this.refreshCleanButtons(payload.response)
      this.refreshShowResult(payload.response)
      this.refreshSideBarSelectedItems(payload.response)
      this.refreshAllCleanButtons(payload.response)
      this.refreshMobileFilterButton(payload.response)
      this.refreshCounter(payload.response)
      this.refreshCategoryCounter(payload.response)
      this.refreshSlider(payload.response, 'rangePriceFilter')
      this.refreshSlider(payload.response, 'saleRangePriceFilter')
      this.refreshSwitchToggle(payload.response, 'inSales')
      this.refreshSwitchToggle(payload.response, 'newArrival')
      this.refreshSwitchToggle(payload.response, 'specialPrice')

      let queryFromUrl = payload.query.startsWith('?page=') ? '' :payload.query.replace('?isRefineSearch=true&q=', '') ?? '';
      let t = queryFromUrl !== '' ? queryFromUrl.split(':') : null
      let urlSearchParams = new URLSearchParams(payload.query);
      this.pageNum = urlSearchParams.get("page") ?? ""
      let regex = /[?&]page=\d+/g;
      if (t) {
        this.query = `:${t.slice(2).join(':')}`
      }
      if(this.query){
          this.query = this.query.replace(regex, '');
      }

      let newQs = payload.query.replace(this.QUERY_PARAMS.base() + '&', '?');
      history.replaceState(null, null, newQs);
    });

    this.$on(SLIDER_EVENTS.handlePrice, ({payload}) => {
        let {query} = this.handlePriceSelector({query: '', selectedSteps: payload.selectedSteps, referenceValue: payload.referenceValue});

        this.minSelected = {...this.minSelected, [payload.id]: payload.min}
        this.maxSelected = {...this.maxSelected, [payload.id]: payload.max}
        this.referenceValue = payload.referenceValue;

        this.priceQuery = query;
        this.qParams.set('prices', this.priceQuery);
        this.applyFilters();
    })

    this.$on(SWITCH_TOGGLE_EVENTS.handleSwitch, ({payload}) => {
      switch(payload.id){
        case 'switch-input-newArrival':
          this.handleSwitch({code: 'newArrival', value: payload.value});
          break;
        case 'switch-input-specialPrice':
          this.handleSwitch({code: 'specialPrice', value: payload.value});
          break;
        case 'switch-input-inSales':
          this.handleSwitch({code: 'inSales', value: payload.value});
          break;
        default:
          console.warn(`Handle switch is not defined. Id: ${payload.id}, value:${payload.value}`)

      }
    })

    this.$on(SLIDER_EVENTS.updateMinMax, ({payload}) => {
      console.warn(`Update min ${payload.min} and max: ${payload.max}`)
      this.minSelected = {...this.minSelected, [payload.id]: payload.min}
      this.maxSelected = {...this.maxSelected, [payload.id]: payload.max}
    })

    this.$on(this.$customEvents.WISHLIST.updateFilter, (label) => {
      console.warn('Update filter', label);
      this.updateSearchResultsCountFromWishlist(label);
    })

    // this.$on(this.$customEvents.WISHLIST.resetFilters, () => {
    //   console.warn('Resetting filters');
    //   this.resetAllFilters();
    // })

    if (this.showResultLabel.length) {
      this.showResultLabel.forEach((button) => {
        button.addEventListener('click', () => {
          console.log('Show results clicked!!');
          this.applyFilters('', true);
        })
      })
    }

    // dom ready
    $(document).ready(() => {
      let $focusElement = $(getFocusElement());
      let handleFocus = hasFocusElement() && $focusElement.length > 0;
      if(handleFocus) {
        this.timedOutScrollToElement($focusElement);
      }
    });

  }

  // INTREND

  bindCloseFilterBar() {
    if (this.showResultButtonList) {

      let that = this;
        this.showResultButtonList.forEach(btn =>
          btn.addEventListener('click', () => {
            that.sideBar.classList.add('hide');
            that.sideBarOverlay.classList.add('hide');
            that.sideBar.classList.remove('show');
            that.sideBarOverlay.classList.remove('show');

            const subMenuSideBar = document.querySelectorAll(this.SELECTORS.subMenuSideBar);
            subMenuSideBar.forEach(menuItem => {
              menuItem.classList.remove('active');
              menuItem.classList.add('hide');
            });
          })
        )
    }
  }

  handleSticky() {
    let _this = this;

    window.addEventListener('scroll', function () {
      let scrollDebounce = _.debounce(function () {

        let distanceFromTop = $(this).scrollTop();
        let isDesktop = window.matchMedia('(min-width: 1024px)').matches;

        if (isDesktop) {
          if (distanceFromTop > _this.filterbarHeight) {
            $('.filter-bar-wrapper').addClass('fixed');
          } else {
            $('.filter-bar-wrapper').removeClass('fixed');
          }
        } else {
          if (distanceFromTop > _this.filterbarHeight) {
            $('.filter-bar-wrapper').addClass('fixed');
          } else {
            $('.filter-bar-wrapper').removeClass('fixed');
          }
        }
      }, 300);
      scrollDebounce();
    })
  }

  handleViewMode(viewMode) {
    if (viewMode === 'V4') {
      // TODO: add event to change view mode
      this.viewModeV4.classList.add('active-icon');
      this.viewModeV6.classList.remove('active-icon');
      if(this.productsContainer.classList.contains("v6")){
        this.productsContainer.classList.remove("v6")
      }
      this.productsContainer.classList.add("v4")
    } else {
      // TODO: add event to change view mode
      if(this.productsContainer.classList.contains("v4")){
        this.productsContainer.classList.remove("v4")
      }
      this.productsContainer.classList.add("v6")
      this.viewModeV6.classList.add('active-icon');
      this.viewModeV4.classList.remove('active-icon');
    }
  }

  onFilterTabItemClick(){
    const filters = document.querySelectorAll(this.SELECTORS.filters)

    const cleanActive = () => {
      filters.forEach(menuItem => {
        menuItem.classList.remove('active');
      });
    };

    const activeItem = (itemIndex) => {
      cleanActive();
      filters.item(itemIndex).classList.add('active');
      filters.item(itemIndex).classList.remove('hide');
      this.$emit(this.$customEvents.FILTERS_EVENTS.subMenuActivation);
    };

    filters.forEach((listItem, index) => {
      listItem.addEventListener('click', () => {
          activeItem(index);
      });
      listItem.addEventListener('keydown', (event) => {
        if (event.key === 'Enter'|| event.keyCode === 13) {
          activeItem(index);
        }
      });
    });

  }

  onSideBarItemClick() {
    const filterList = document.querySelectorAll(this.SELECTORS.filterList);

    const cleanActive = () => {
      filterList.forEach(menuItem => {
        menuItem.classList.remove('active');
      });
    };

    const activeItem = (itemIndex) => {
      cleanActive();
      filterList.item(itemIndex).classList.add('active');
      filterList.item(itemIndex).classList.remove('hide');
      this.$emit(this.$customEvents.FILTERS_EVENTS.active); 
    };

    filterList.forEach((listItem, index) => {
      listItem.addEventListener('click', () => {
          activeItem(index);
      });
      listItem.addEventListener('keydown', (event) => {
        if (event.key === 'Enter'|| event.keyCode === 13) {
          activeItem(index);
        }
      });
    });

  }

  handleSubItemMenu() {
    this.$on(
      this.$customEvents.FILTERS_EVENTS.active,
      () => {
        const activeItem = document.querySelector(
          this.SELECTORS.activeItem
        );
        const activeItemSubMenuSelector = `[data-filter-side-bar-sub-menu=${
          activeItem.dataset.sideBarFiltersItem
        }]`;
        const activeItemSubMenu = document.querySelector(activeItemSubMenuSelector);

        if (activeItemSubMenu) {
          activeItemSubMenu.classList.add('show');
          activeItemSubMenu.classList.remove('hide');
        }
      }
    )
  }

  handleSubItemMenuFromFilterBar() {
    this.$on(
      this.$customEvents.FILTERS_EVENTS.subMenuActivation,
      () => {
        const activeItem = document.querySelector(
          this.SELECTORS.filterActive
        );
        const activeItemSubMenuSelector = `[data-filter-side-bar-sub-menu=${
          activeItem.dataset.filtersItem
        }]`;
        const activeItemSubMenu = document.querySelector(activeItemSubMenuSelector);

        // Show filter sub menu
        if (activeItemSubMenu) {
          activeItemSubMenu.classList.add('show');
          activeItemSubMenu.classList.remove('hide');
        }

        // Show in background sidebar and overlay
        this.sideBar.classList.add('show');
        this.sideBarOverlay.classList.add('show');
        this.sideBar.classList.remove('hide');
        this.sideBarOverlay.classList.remove('hide');

        //focus on first side bar element
          const subMenuVisible = document.querySelector('.filter-side-bar-sub-menu.show:not(.hide)');
          if (subMenuVisible) {
            trapFocusOnModal(subMenuVisible);
            const backButton = subMenuVisible.querySelector('.filter-side-bar-sub-menu-back');
            if (backButton) {
              setTimeout(() => {
                backButton.focus({ preventScroll: true });
              }, 200);
            }
          } 

      }
    )
  }

  onCloseSideBarSubMenu() {

    const subMenuSideBar = document.querySelectorAll(this.SELECTORS.subMenuSideBar);
    const filterListClose = document.querySelectorAll(this.SELECTORS.filterListClose);

    const cleanActive = () => {
      subMenuSideBar.forEach(menuItem => {
        menuItem.classList.remove('active');
        menuItem.classList.add('hide');
      });
    };

    filterListClose.forEach((listItem) => {
      listItem.addEventListener('click', () => {
          cleanActive();
      });
      listItem.addEventListener('keydown', (event) => {
          if (event.key === 'Enter'|| event.keyCode === 13) {
          cleanActive();
        }
      });
      
    });

  }

  onCloseSideBarFromSubMenu() {
    const subMenuSideBar = document.querySelectorAll(this.SELECTORS.subMenuSideBar);
    const filterListCloseAll = document.querySelectorAll(this.SELECTORS.filterListCloseAll);

    const cleanActive = () => {
      const filterSelected = document.querySelector('.filter-bar-item.active');
      filterSelected.focus()
      subMenuSideBar.forEach(menuItem => {
        menuItem.classList.remove('active');
        menuItem.classList.add('hide');
      });
    };

    filterListCloseAll.forEach((listItem) => {
      listItem.addEventListener('click', () => {
          cleanActive()
          this.sideBar.classList.add('hide');
          this.sideBarOverlay.classList.add('hide');
          this.sideBar.classList.remove('show');
          this.sideBarOverlay.classList.remove('show');
      });
      listItem.addEventListener('keydown', (event) => {
        if (event.key === 'Enter'|| event.keyCode === 13) {
          cleanActive()
          this.sideBar.classList.add('hide');
          this.sideBarOverlay.classList.add('hide');
          this.sideBar.classList.remove('show');
          this.sideBarOverlay.classList.remove('show');
        }
      });
    });

  }

  addClickElementFilter(){
    const filters = document.querySelectorAll(this.SELECTORS.filterElement);

    filters.forEach((filter) => {
        filter.addEventListener('click', e => {
            let { filterElement, filterCategory } = filter.dataset;
            let triggerApi = false

            if (!filter.className.includes('unavailable')) {

                // SortBy allow only one element to be selected
                if (filterCategory === 'sortBy') {
                    // Remove other selections and clean query
                    filters.forEach((f) => {
                      if (f.dataset.filterCategory === 'sortBy' && filterElement !== f.dataset.filterElement) {
                        f.classList.remove('selected')
                      }
                    })

                    // Add new selected element (not allow to remove selected, only switch selection)
                    if (!e.target.classList.contains('selected')) {
                        filter.classList.add('selected');
                        triggerApi = true

                        this.qParams.set(filterCategory, filterElement)
                        this.trackingComponent.actions.filterTracking(filterCategory, filterElement);
                    }

                } else {
                    if (e.target.classList.contains('selected')) {            // Deselect element
                        console.log('removing class selected');
                        filter.classList.remove('selected');
                        triggerApi = true

                        this.qParams.delete(filterCategory);

                        // Default rule for fitting with code NONE
                        if (filterCategory === 'comfortable') this.qParams.set(filterCategory, 'NONE');
                    } else {                                                  // Select element
                        console.log('adding class selected');
                        filter.classList.add('selected');
                        triggerApi = true

                        this.qParams.set(filterCategory, filterElement);

                        // Default rule for fitting with code NONE
                        if (filterCategory === 'comfortable') this.qParams.set(filterCategory, 'NONE');
                        filterCategory === 'comfortable' ?
                          this.trackingComponent.actions.filterTracking(filterCategory, 'NONE') :
                          this.trackingComponent.actions.filterTracking(filterCategory, filterElement);
                    }
                }

                if (triggerApi) this.applyFilters();
            }
        });
    });

  }

  handlePriceSelector({query, selectedSteps, referenceValue}) {
    if (selectedSteps && selectedSteps !== undefined) {
        // Populate query
        if (selectedSteps.length === 1) {
          query = query.concat(`:${referenceValue}:${selectedSteps[0]}`);
        } else {
          selectedSteps.sort((a, b) => a - b);
          selectedSteps.forEach((step, index) => {
            if (index > 0) query = query.concat(`:${referenceValue}:${step}`);
          });
        }
    }

    return { query }
  }

  handleSwitch({code, value}) {
    if (value == true) this.qParams.set(code, value);
    else this.qParams.delete(code)

    if (this.pageNum) {
        this.qParams.set('page', this.pageNum);
    }

    // window.location.search = this.qParams;
    if (code === 'newArrival') {
      this.applyFilters('', true);
    } else {
      this.applyFilters('', false);
    }
  }

  applyFilters(page = null, execute = false, fullQuery = null) {
    let query = '';
    if (fullQuery) {
      query += fullQuery;
    } else {
      query = 'isRefineSearch=true&q=';
      if (!(this.qParams.has('isRefineSearch'))) this.qParams.set('isRefineSearch', 'true');

      let isSorted = false;
      const sortByElements = document.querySelectorAll('[data-filter-category="sortBy"]');
      for (const el of sortByElements) {
          if (el && el.classList.contains('selected')) isSorted = el.getAttribute('data-filter-element');
      }

      if (this.textSearch) {
          query += this.textSearch;
      }
      if (isSorted) {
          query += `:${isSorted}`
      } else {
          query += ':topRated'
      }

      const newArrival = document.querySelector('#switch-input-newArrival');
      if (newArrival && newArrival.checked) {
          query += ':newArrival:true';
      }

      const specialPrice = document.querySelector('#switch-input-specialPrice');
      if (specialPrice && specialPrice.checked) {
          query += ':specialPrice:true';
      }

      const inSales = document.querySelector('#switch-input-inSales');
      if (inSales && inSales.checked) {
          query += ':inSales:true';
      }

      const activeFilters = [...this.filterComponents].filter(f => f.classList.contains('selected'));
      activeFilters.forEach(f => {
          const key = f.getAttribute('data-filter-category');
          const value = f.getAttribute('data-filter-element');
          query += `:${key}:${value}`;
      });

      if (this.priceQuery) {
          const min = this.minSelected[`slider-${this.referenceValue}`];
          query += this.priceQuery;
          query += `&prices=${this.priceQuery}`;
          query += `&min=${min}`;
          if (execute) {
            const max = this.maxSelected[`slider-${this.referenceValue}`];
            this.trackingComponent.actions.filterTracking(this.referenceValue, `${min}-${max}`)
          }
      } else if (this.qParams.get('prices')) {
          const min = this.qParams.get('min');
          query += this.qParams.get('prices');
          query += `&prices=${this.qParams.get('prices')}`;
          query += `&min=${min}`;
          if (execute) {
            const max = this.maxSelected[`slider-${this.referenceValue}`];
            this.trackingComponent.actions.filterTracking(this.referenceValue, `${min}-${max}`)
          }
      }

      if (page) {
        query += `&page=${page}`;
      }

      if (this.textSearch) {
          query += `&text=${this.textSearch}`;
      }

      this.query = query;
    }

    if (execute) window.location.search = query;
  }

  shortcutResetFilters(){
    this.resetAllFilters();

    // clean price filters
    this.qParams.delete('prices');
    if (document.querySelector('#switch-input-newArrival')) document.querySelector('#switch-input-newArrival').checked = false;
    if (document.querySelector('#switch-input-specialPrice')) document.querySelector('#switch-input-specialPrice').checked = false;
    if (document.querySelector('#switch-input-inSales')) document.querySelector('#switch-input-inSales').checked = false;

    this.sortQuery = ':topRated';
    this.query = '';

    //window.location.search = ''
    let currentUrl = window.location.href
    let newUrl = currentUrl.split('?')[0]
    window.history.replaceState( {} , '', newUrl );

    console.warn('onResetFilterClick')
    this.applyFilters('', true)
  }

  onResetFilterClick() {

    const resetAllFilterButton = document.querySelector(this.SELECTORS.resetAllFilterButton);

    resetAllFilterButton.addEventListener('click', () => {
        this.shortcutResetFilters();

    })

  }

  onResetFilterCategoryClick(){
    const resetCategoryFilterButtons = document.querySelectorAll(this.SELECTORS.resetCategoryFilterButtons)
    console.warn('onResetFilterCategoryClick', {resetCategoryFilterButtons})

    resetCategoryFilterButtons.forEach(b => {
      b.addEventListener('click', () => {
        console.warn('onResetFilterCategoryClick', {b})
        if (b.dataset.filterSideBarSubReset === 'price') { // Custom filter group
          this.cleanQueryPrice('rangePriceFilter')
          this.resetSlider('rangePriceFilter')

          this.resetSwitchToggle('specialPrice')
          this.cleanToggle('specialPrice')

          this.resetSwitchToggle('inSales')
          this.cleanToggle('inSales')
        }
        if (b.dataset.filterSideBarSubReset === 'priceSales') { // Custom filter group sales
          this.cleanQueryPrice('saleRangePriceFilter')
          this.resetSlider('saleRangePriceFilter')

          this.resetCategoryFilters('saleRangePercentageFilter')
          this.cleanRangePercentage('saleRangePercentageFilter')
        }
        if (b.dataset.filterSideBarSubReset === 'sortBy') {
          this.resetSortBy()
          this.cleanQuery(b.dataset.filterSideBarSubReset)
        } else {
          this.resetCategoryFilters(b.dataset.filterSideBarSubReset)
          this.cleanQuery(b.dataset.filterSideBarSubReset)
        }

        console.warn('onResetFilterCategoryClick')
      })
    })
  }

  cleanQuery(category){
    const filters = document.querySelectorAll(this.SELECTORS.filterElement);
    filters.forEach((filter) => {
      if (filter.dataset.filterCategory === category) {
        let tempQ = this.query.replace('%20', ' ')
        this.query = tempQ.replace(`:${filter.dataset.filterCategory}:${filter.dataset.filterElement}`, '')
      }
    })
  }

  cleanToggle(category) {
    this.query = this.query.replace(`:${category}:true`, '')
  }

  cleanRangePercentage(category) {
    // CLEAN QUERY
    let t = this.query.split(':')
    let selectedValues = []

    console.log(category)

    let prevItem = null
    t.forEach(el => {

      if (
        el &&
        el !== '' &&
        el !== undefined &&
        el !== category &&
        (
          !prevItem ||
          (prevItem !== '' &&
          prevItem !== undefined &&
          prevItem !== category)
        )
      ) {
        selectedValues.push(el)
      }
      prevItem = el
    })

    if(selectedValues && selectedValues.length > 0) this.query = ':'.concat(selectedValues.join(':'))
    else this.query = ''
  }

  cleanQueryPrice(category){

    // RESET SLIDER
    //this.$emit(SLIDER_EVENTS.reset, { id: category });

    delete this.minSelected[`slider-${category}`]
    delete this.maxSelected[`slider-${category}`]
    // CLEAN QUERY
    let t = this.query.split(':')
    let selectedValues = []

    let prevItem = null
    t.forEach(el => {

      if (
        el &&
        el !== '' &&
        el !== undefined &&
        el !== category &&
        (
          !prevItem ||
          (prevItem !== '' &&
          prevItem !== undefined &&
          prevItem !== category)
        )
      ) {
        selectedValues.push(el)
      }
      prevItem = el
    })

    if(selectedValues && selectedValues.length > 0) this.query = ':'.concat(selectedValues.join(':'))
    else this.query = ''
  }

  // RESET DEGLI SLIDER
  resetSlider(category) {
    this.$emit(SLIDER_EVENTS.reset, { id: category });
    this.priceQuery = '';
    this.qParams.delete('prices');
  }

  resetSwitchToggle(category) {
    this.$emit(SWITCH_TOGGLE_EVENTS.reset, { id: category });
    this.$emit(SWITCH_TOGGLE_EVENTS.handleDisabled, { id: category, disabled: "false" });
  }

  resetCategoryFilters(category){
    const filters = document.querySelectorAll(this.SELECTORS.filterElement);
    filters.forEach((filter) => {
      if (filter.dataset.filterCategory === category) {
        filter.classList.remove('selected');
      }
    })
  }

  resetSortBy() {
    const filters = document.querySelectorAll(this.SELECTORS.filterElement);
    filters.forEach((filter) => {
      if (filter.dataset.filterCategory === 'sortBy') {
        if (filter.id !== 'sortBy-topRated') filter.classList.remove('selected');
        else filter.classList.add('selected');
      }
    })

    this.sortQuery = ':topRated'
  }

  resetAllFilters(){
    const filters = document.querySelectorAll(this.SELECTORS.filterElement);
    filters.forEach((filter) => {
        filter.classList.remove('selected');
    })

    // RESET DEGLI SLIDER
    this.$emit(SLIDER_EVENTS.reset, { id: 'rangePriceFilter' });
    this.$emit(SLIDER_EVENTS.reset, { id: 'saleRangePriceFilter' });

    // RESET DEGLI SWITCH
    this.$emit(SWITCH_TOGGLE_EVENTS.reset, { id: 'newArrival' });
    this.$emit(SWITCH_TOGGLE_EVENTS.handleDisabled, { id: 'newArrival', disabled: "false" });
    this.$emit(SWITCH_TOGGLE_EVENTS.reset, { id: 'specialPricesToggle' });
    this.$emit(SWITCH_TOGGLE_EVENTS.handleDisabled, { id: 'specialPricesToggle', disabled: "false" });
    this.$emit(SWITCH_TOGGLE_EVENTS.reset, { id: 'salesToggle' });
    this.$emit(SWITCH_TOGGLE_EVENTS.handleDisabled, { id: 'salesToggle', disabled: "false" });
  }

  refreshFilters(response) {
    // Update sidebar filter option (available / unavailable)
    document.querySelectorAll(this.SELECTORS.filterElement).forEach(input => {

      if(response.querySelector('#' + CSS.escape(input.id)) == null && !input.className.includes('selected')) {
        input.classList.add('unavailable');
      } else {
        input.classList.remove('unavailable');
      }

    });
  }

  refreshSlider(response, sliderId, isReset = false) {
    let slider = document.querySelector(`[data-slider=${sliderId}]`)

    if (slider) {
      let temp = response.querySelector('#' + CSS.escape(slider.id));

      let min = this.minSelected[slider.id]
      let max = this.maxSelected[slider.id]


      if (temp) {
        if (isReset)this.$emit(SLIDER_EVENTS.refresh, { id: sliderId, dataset: temp.dataset, min: null, max: null })
        else this.$emit(SLIDER_EVENTS.refresh, { id: sliderId, dataset: temp.dataset, min, max })
      }

    }
  }

  refreshSwitchToggle(response, switchToggleId) {
    let switchToggle = document.querySelector(`[data-switch-toggle=${switchToggleId}]`)

    if (switchToggle) {
      let temp = response.querySelector('#' + CSS.escape(switchToggle.id));

      if (temp) {
        this.$emit(SWITCH_TOGGLE_EVENTS.handleDisabled, { id: switchToggleId, disabled: temp.disabled.toString() });
      } else {
        this.$emit(SWITCH_TOGGLE_EVENTS.handleDisabled, { id: switchToggleId, disabled: "true" });
      }
    }
  }

  refreshFilterBar(response) {
    // Update filterBar option (selected / not selected)
    document.querySelectorAll(this.SELECTORS.filters).forEach(filter => {
      let newF = response.querySelector('#' + CSS.escape(filter.id));

      if(newF){
        filter.className = newF.className
        filter.innerHTML = newF.innerHTML
      }
    })
  }

  refreshAllCleanButtons(response) {
    let newCleanAll = response.querySelector('#' + CSS.escape(this.cleanAll.id));

    if(newCleanAll) {
      if (newCleanAll.className.includes('show') && !this.cleanAll.className.includes('show')){
          this.cleanAll.classList.add('show');
      } else if (!newCleanAll.className.includes('show') && this.cleanAll.className.includes('show')) {
          this.cleanAll.classList.remove('show');
      }
    }
  }

  refreshCleanButtons(response) {
    document.querySelectorAll(this.SELECTORS.cleanSingle).forEach(cs => {
      let newCs = response.querySelector('#' + CSS.escape(cs.id))

      cs.className = newCs?.className ?? cs?.className
    });

  }

  refreshShowResult(response) {
    document.querySelectorAll(this.SELECTORS.showResultLabel).forEach(l => {
      let newL = response.querySelector('#' + CSS.escape(l.id))

      l.className = newL?.className ?? l?.className
      l.innerHTML = newL?.innerHTML ?? l?.innerHTML
    });

  }

  refreshSideBarSelectedItems(response) {
    document.querySelectorAll(this.SELECTORS.filterCategory).forEach(l => {
      let newL = response.getElementById(l.id)

      l.className = newL?.className ?? l?.className
    });
    document.querySelectorAll(this.SELECTORS.filterOptionsSelected).forEach(l => {
      let newL = response.getElementById(l.id)

      l.className = newL?.className ?? l?.className
      l.innerHTML = newL?.innerHTML ?? l?.innerHTML
    });
  }

  refreshMobileFilterButton(response) {
    if (this.mobileFilterButton){
      let newMobileFilterButton = response.querySelector('#' + CSS.escape(this.mobileFilterButton.id));

      if (newMobileFilterButton) {
        this.mobileFilterButton.innerHTML = newMobileFilterButton.innerHTML
        this.mobileFilterButton.className = newMobileFilterButton.className
      }
    }
  }

  refreshCounter(response) {
    if (this.productCounter){
      let temp = response.querySelector('#' + CSS.escape(this.productCounter.id));

      if (temp) {
        this.productCounter.innerHTML = temp.innerHTML
        this.productCounter.className = temp.className
      }
    }
  }

  refreshCategoryCounter(response) {

    document.querySelectorAll(this.SELECTORS.categoryFilterActiveCounter)?.forEach(l => {

      if (l) {
        let newL = response.getElementById(l.id)
        l.innerHTML = newL?.innerHTML ?? l?.innerHTML
      }
    });
  }

  // END INTREND

  timedOutScrollToElement($element) {
    setTimeout(()=> {
      this.scrollToElement($element);
    }, 500);
  }

  scrollToElement($element) {
    $element.get(0).scrollIntoView({block: 'center', inline: 'nearest', behavior: 'smooth'});
  }

  get QUERY_PARAMS() {
    return {
      base: () => {
        if(document.body.classList.contains('t-search')) {
          return '?partial=true&save=false';
        }
        return '?save=false';
      },
      pagination: (page) => {
        let paginationQueryBit = '';
        if(page) {
          // currentPage
          paginationQueryBit = '&page=' + page;
        }
        // if not cached
        return paginationQueryBit;
      },
      textSearch: () => {
        // on search page
        if(document.body.classList.contains('t-search')) {
          // other catches
          if(typeof this.qs == 'undefined' || this.qs == null) return;
          if(typeof this.qs.getAttribute('value') != null) {
            let q = this.qs.getAttribute('value');
            let matchString = new RegExp('[^:]*', '');
            let search = q.match(matchString);
            return search[0];
          }
        }
        return '';
      },
      sortBy: (qs = false) => {
        // if there is no sort i exit
        if(typeof this.filterSortBy == 'undefined' || this.filterSortBy == null) return;
        let sort = this.filterSortBy.value;
        // return the sort
        if(qs) {
          return '&sort=' + sort + ':';
        } else {
          return ':' + sort;
        }
      },
      priceRange: (isReset) => {
        let priceQuery = this.PriceRangeComponent.buildQuery(isReset);
        return priceQuery;
      },
      saleRange: () => {
        let saleRangeQuery = this.SaleRangeComponent.buildQuery();
        return saleRangeQuery;
      },
      formData: () => {
        // query
        let filterQuery = '';
        let isSales = false;
        // form inputs
        document.querySelectorAll(this.OLD_SELECTORS.filtersInputs).forEach(input => {
          if(input.checked) {
            if(input.id.indexOf('inSales') !== -1) {
              isSales = true;
              //tracking
              this.trackingComponent.actions.filterTracking(isSales, true);
            }
            filterQuery = filterQuery + ':' + input.name + ':' + input.value;
            //tracking
            this.trackingComponent.actions.filterTracking(input.name, input.value);
            if(isSales == false) {
              filterQuery.replace('inSales:true:', '');
            }
          }
        });
        // order
        //filterQuery = filterQuery + ':' + this.filterSortBy.name + ':' + this.filterSortBy.value;
        //
        return filterQuery;
      }

    }
  }

  // build the filters
  buildQuery(page = false, isReset) {
    // get full query
    let fullQuery =
      this.QUERY_PARAMS.base() +
      '&isRefineSearch=true&q=' +
      this.QUERY_PARAMS.textSearch() +
      this.QUERY_PARAMS.sortBy() +
    //   this.QUERY_PARAMS.priceRange(isReset) +
      this.QUERY_PARAMS.saleRange() +
      this.QUERY_PARAMS.formData() +
      this.QUERY_PARAMS.pagination(page);

    this.log('fullQuery ', fullQuery);
    return fullQuery;
  }

  // filter function
  filterQuery(page, query = '', isReset = false) {
    this.log('launch query');
    // build the query
    if(query === '') {
      query = this.buildQuery(page, isReset);
    }
    // main products container
    // get the page
    this.getFilteredPage(query).then(res => {
      // render the page
      this.renderPage(res, query);
    });
  }

  // get page via ajax function
  getFilteredPage(query) {
    // get content
    return this.ajaxAction.getPage(query);
  }

  // render results
  renderPage(res, query = '', isReset) {
    // html response
    let response = new DOMParser().parseFromString(res, 'text/html');
    // render content
    this.ajaxAction.renderContent(res, 'products');

    this.$emit(this.$customEvents.FILTERS_EVENTS.pageLoaded);
    if (isReset) {
      this.$emit(this.$customEvents.FILTERS_EVENTS.reset, {response, res, query});
    } else {
      this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {response, res, query});
    }
    // scroll to top
    window.scrollTo(0, 0);
  }

  importLibrary(elem) {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        this.initCarousels(elem);
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  initCarousels(elem) {
    let carousels = document.querySelectorAll(".carousel-wrapper");
    carousels.forEach(carousel => {
        if(carousel.classList.contains("slick-initialized")){
          $(carousel).slick("unslick")
        }
        carousel.addEventListener("mouseover",() => {
            let parentNode = carousel.parentNode;
            let arrowL = parentNode.querySelector(this.SELECTORS.prevArrow);
            let arrowR = parentNode.querySelector(this.SELECTORS.nextArrow);
            if(arrowL || arrowR){
              arrowL.addEventListener("click",(event) => {
                  event.preventDefault();
                  event.stopPropagation();
              })
              arrowR.addEventListener("click",(event) => {
                  event.preventDefault();
                  event.stopPropagation();
              })
              if(!carousel.classList.contains("slick-initialized")){
                $(carousel).slick({
                  prevArrow: arrowL,
                  nextArrow: arrowR,
                });
              }
            }
          });
        })
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
